import { Type, type Static } from '@sinclair/typebox';
import { PublicAccountSchema } from './account.schema';

export const AdminAccountResponseSchema = Type.Composite(
  [
    PublicAccountSchema,
    Type.Object({
      is_proxy_country_offered: Type.Optional(
        Type.Boolean({
          description:
            'Whether Unipile offers automatic proxies in the rotation country for this account’s provider. If false, choose a country included in the proxy offering. If true, a proxy may still be temporarily unavailable for this account. Omitted when no rotation country is set or the account does not use automatic proxies.',
        }),
      ),
    }),
  ],
  { description: 'Account details for the Dashboard, including whether Unipile offers proxies in the rotation country.' },
);

export type AdminAccountResponse = Static<typeof AdminAccountResponseSchema>;

export const ListAccountsResponseSchema = Type.Object({
  object: Type.Literal('Accounts'),
  data: Type.Array(PublicAccountSchema),
  has_more: Type.Boolean({ description: 'Whether there are more accounts to fetch.' }),
});

export const AccountsStatusResponseSchema = Type.Object({
  object: Type.Literal('AccountsStatus'),
  running: Type.Number({ description: 'The number of accounts currently running.' }),
  disconnected: Type.Number({ description: 'The number of accounts currently disconnected.' }),
  errored: Type.Number({ description: 'The number of accounts currently errored.' }),
  degraded: Type.Number({ description: 'The number of accounts with mixed running and errored products.' }),
  partial: Type.Number({ description: 'The number of accounts with mixed product statuses requiring inspection.' }),
});

export type ListAccountsResponse = Static<typeof ListAccountsResponseSchema>;
export type AccountsStatusResponse = Static<typeof AccountsStatusResponseSchema>;

export const AccountSyncResponseSchema = Type.Object(
  {
    object: Type.Literal('AccountSyncRequested', { description: 'Object type identifier, always "AccountSyncRequested".' }),
    request_id: Type.String({ description: 'Identifier of the history synchronization request sent to the provider.' }),
  },
  { description: 'Confirmation that a full history synchronization was requested. Completion is asynchronous.' },
);

export type AccountSyncResponse = Static<typeof AccountSyncResponseSchema>;
